<main>
  @if (loading) {
    <div
      class="text-center"
      style="width: 100%; position: relative; height: 250px; vertical-align: middle; top: 45%"
    >
      <mat-spinner
        style="display: inline-block; position: relative; margin-top: 5em"
        diameter="24"
      ></mat-spinner>
    </div>
  }

  @if (showInfo && !loading && userData.isStaff) {
    <div>
      <!-- first part to as lpk and barcode -->
      @if (interDiv && !ultimateDiv && !PatronCheck && cid) {
        <div class="login-background div1">
          <div
            class="login-form col-12 col-sm-10 col-md-8 col-lg-6 offset-sm-1 offset-md-2 offset-lg-3"
          >
            <div class="card login-card">
              <button class="btn btn-link logout-button" type="button" (click)="onLogout()">
                Logout
              </button>
              <div id="tabs-container">
                <img src="./assets/images/patron-lookup-demo.png" alt="patron lookup image" />
              </div>
              <div class="card-block">
                @if ((cid | trimLower) !== 'rail') {
                  <h6 style="margin-bottom: 30px">
                    {{ instructionalText1 }}
                  </h6>
                }
                @if ((cid | trimLower) === 'rail') {
                  <div style="margin-bottom: 30px">
                    <h6>
                      Select the patron’s library then enter their barcode. Valid patron barcodes
                      will not be found unless their home library is selected. <br /><br />
                      If a patron’s library is not listed in the following drop down menu, call
                      their library for their status and ask them to contact
                      <a href="mailto:info@findmoreillinois.org">info&#64;findmoreillinois.org</a>
                      to join this service.
                    </h6>
                  </div>
                }
                <form
                  #interForm
                  class="form-horizontal"
                  autocomplete="off"
                  [formGroup]="intermediateForm"
                >
                  <!-- Get Library drop down -->
                  <div id="lib-dropdown">
                    <mat-form-field style="width: 100%" class="clearfix">
                      <!-- eslint-disable @angular-eslint/template/no-autofocus -->
                      <input
                        #libdropdown
                        autofocus
                        id="searchBox"
                        type="text"
                        matInput
                        [placeholder]="
                          (cid | trimLower) !== 'rail' ? libraryDropText1 : libraryDropText2
                        "
                        [title]="(cid | trimLower) !== 'rail' ? libraryDropText1 : libraryDropText2"
                        [formControl]="filterLibrary"
                        [(ngModel)]="library"
                        [matAutocomplete]="auto"
                      /><i
                        class="fa fa-chevron-down d-inline-block pointer"
                        aria-hidden="true"
                        (click)="showLibList()"
                      ></i>
                      <mat-autocomplete #auto="matAutocomplete">
                        @if (libraries) {
                          <div>
                            @for (library of libraries; track library; let i = $index) {
                              <mat-option
                                value="{{ library.lid }}:{{ library.name }}"
                                innerHTML="{{ library.lid }}:{{ library.name }}"
                              >
                              </mat-option>
                            }
                          </div>
                        }
                      </mat-autocomplete>
                    </mat-form-field>
                  </div>
                  <!-- User and Password -->
                  <mat-form-field style="width: 100%" class="clearfix">
                    <input
                      type="text"
                      matInput
                      formControlName="user"
                      [placeholder]="(cid | trimLower) !== 'rail' ? userNameText1 : userNameText2"
                      [title]="(cid | trimLower) !== 'rail' ? userNameText1 : userNameText2"
                      autocomplete="nope"
                    />
                  </mat-form-field>
                  <!-- submit  -->
                  <div class="text-end clearfix">
                    <button
                      role="button"
                      aria-label="Submit"
                      class="btn btn-primary"
                      type="button"
                      [disabled]="!intermediateForm.valid && !userData.isStaff"
                      (click)="interSubmit()"
                      (keyup.enter)="interSubmit()"
                    >
                      @if (!btnLoading) {
                        <span style="width: 175px">Submit</span>
                      }
                      @if (btnLoading) {
                        <span style="width: 175px">
                          <i class="fa fa-spinner fa-pulse fa-fw"></i>
                        </span>
                      }
                    </button>
                    <button
                      role="button"
                      aria-label="Cancel"
                      type="button"
                      class="btn btn-link margin-0-10"
                      (click)="firstCancel()"
                    >
                      Cancel
                    </button>
                  </div>
                </form>
              </div>
            </div>
          </div>
        </div>
      }
      <!-- second part to as password -->
      @if (!interDiv && ultimateDiv && !PatronCheck && cid) {
        <div class="login-background div2">
          <div
            class="login-form col-12 col-sm-10 col-md-8 col-lg-6 offset-sm-1 offset-md-2 offset-lg-3"
          >
            <div class="card login-card">
              <div id="tabs-container">
                <img src="./assets/images/patron-lookup-demo.png" alt="patron lookup image" />
              </div>
              <div class="card-block">
                <h6 style="margin-bottom: 30px">{{ interimText1 }}</h6>
                <form
                  #ultiForm
                  class="form-horizontal"
                  autocomplete="off"
                  [formGroup]="ultimateForm"
                >
                  <!-- User and Password -->
                  <mat-form-field style="width: 100%" class="clearfix">
                    <!-- eslint-disable @angular-eslint/template/no-autofocus -->
                    <input
                      #libdropdown2
                      autofocus
                      type="password"
                      matInput
                      formControlName="password"
                      title="Password"
                      autocomplete="nope"
                      [placeholder]="interimText2"
                    />
                  </mat-form-field>
                  <!-- submit  -->
                  <div class="text-end clearfix">
                    <button
                      role="button"
                      aria-label="Submit"
                      class="btn btn-primary"
                      type="button"
                      [disabled]="!ultimateForm.valid"
                      (click)="ultimateSubmit()"
                      (keyup.enter)="ultimateSubmit()"
                    >
                      @if (!btnLoading) {
                        <span style="width: 175px">Submit</span>
                      }
                      @if (btnLoading) {
                        <span style="width: 175px">
                          <i class="fa fa-spinner fa-pulse fa-fw"></i>
                        </span>
                      }
                    </button>
                    <button
                      role="button"
                      aria-label="Cancel"
                      type="button"
                      class="btn btn-link margin-0-10"
                      (click)="secondCancel()"
                    >
                      Cancel
                    </button>
                  </div>
                </form>
              </div>
            </div>
          </div>
        </div>
      }
      <!-- final result -->
      @if (!interDiv && !ultimateDiv && PatronCheck) {
        <div class="login-background div3">
          @if (PatronCheck) {
            <div
              class="login-form col-12 col-sm-10 col-md-8 col-lg-6 offset-sm-1 offset-md-2 offset-lg-3"
            >
              <div class="card login-card">
                <button class="btn btn-link logout-button" type="button" (click)="onLogout()">
                  Logout
                </button>
                <div id="tabs-container">
                  <img src="./assets/images/patron-lookup-demo.png" alt="patron lookup image" />
                </div>
                @if (PatronCheck?.goodStanding) {
                  <div class="card-block">
                    @if (
                      ($safeNavigationMigration(PatronCheck?.standingMessage) | trimLower) ===
                        'patron is in good standing.' && (cid | trimLower) !== 'rail'
                    ) {
                      <h5>
                        {{ PatronCheck?.standingMessage }}
                      </h5>
                    }
                    @if (
                      ($safeNavigationMigration(PatronCheck?.standingMessage) | trimLower) ===
                        'patron is in good standing.' && (cid | trimLower) === 'rail'
                    ) {
                      <h5>
                        {{ patronStatusText1 }}
                      </h5>
                    }
                    @if (
                      ($safeNavigationMigration(PatronCheck?.standingMessage) | trimLower) !==
                      'patron is in good standing.'
                    ) {
                      <h5>
                        {{ PatronCheck?.standingMessage }}
                      </h5>
                    }
                    @if (PatronCheck?.expireDate !== '') {
                      <h5>Expiration Date: {{ PatronCheck?.expireDate }}</h5>
                    }
                    @if (PatronCheck?.expireDate === '') {
                      <h5>Expiration Date: Not Available</h5>
                    }
                    <div class="text-end clearfix">
                      <button
                        role="button"
                        aria-label="Close"
                        type="button"
                        class="btn btn-link margin-0-10"
                        (click)="close()"
                      >
                        {{ (cid | trimLower) !== 'rail' ? closeButtonText1 : closeButtonText2 }}
                      </button>
                    </div>
                  </div>
                }
                @if (!PatronCheck?.goodStanding) {
                  <div class="card-block">
                    @if (
                      ($safeNavigationMigration(PatronCheck?.standingMessage) | trimLower) ===
                        'patron is not in good standing.' && (cid | trimLower) !== 'rail'
                    ) {}
                    <h5>
                      {{ PatronCheck?.standingMessage }}
                    </h5>
                    @if (
                      ($safeNavigationMigration(PatronCheck?.standingMessage) | trimLower) ===
                        'patron is not in good standing.' && (cid | trimLower) === 'rail'
                    ) {
                      <h5>
                        {{ patronStatusText2 }}
                      </h5>
                    }
                    @if (
                      ($safeNavigationMigration(PatronCheck?.standingMessage) | trimLower) !==
                      'patron is not in good standing.'
                    ) {
                      <h5>
                        {{ PatronCheck?.standingMessage }}
                      </h5>
                    }
                    @if (PatronCheck?.expireDate !== '') {
                      <h5>Expiration Date: {{ PatronCheck?.expireDate }}</h5>
                    }
                    @if (PatronCheck?.expireDate === '') {
                      <h5>Expiration Date: Not Available</h5>
                    }
                    <div class="text-end clearfix">
                      <button
                        role="button"
                        aria-label="Close"
                        type="button"
                        class="btn btn-link margin-0-10"
                        (click)="close()"
                      >
                        {{ (cid | trimLower) !== 'rail' ? closeButtonText1 : closeButtonText2 }}
                      </button>
                    </div>
                  </div>
                }
              </div>
            </div>
          }
        </div>
      }
    </div>
  }
</main>
